module.exports = __webpack_public_path__ + "static/media/saver-global-logo-white.a22f72a2.svg";